import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, ListItem, ListItemText, ListItemIcon, Typography, Box
} from '@material-ui/core';
import { Folder, InsertDriveFile } from '@material-ui/icons';
import axios from 'axios';
import { BASE_URL } from "../global/Server/endpoints";
import FeedbackBar from "../feedbackBar/FeedbackBar";

class RecycleBin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      feedback: { open: false, message: '', severity: '' },
      deleteConfirm: null, // file to delete
    };
  }

  openFeedback = (status, message) => {
    this.setState({ feedback: { open: true, severity: status, message } });
  };

  closeFeedback = () => {
    this.setState({ feedback: { open: false, severity: '', message: '' } });
  };

  loadRecycleBin = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await axios.post(
          `${BASE_URL}/folder/recycleBin`,
          { parentId: this.props.parentId }, // POST body
          { headers: { Authorization: `Bearer ${token}` } } // headers
      );

      if (res.data.success) {
        this.setState({ files: res.data.files });
      }
    } catch (err) {
      this.openFeedback('error', 'Failed to load recycle bin: ' + err.message);
    }
  };



  async componentDidMount() {
    await this.loadRecycleBin();
  }

  restoreFile = async (file) => {
    const token = localStorage.getItem('token');
    try {
      const res = await axios.post(`${BASE_URL}/folder/restoreNode`, { id: file.id }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data.success) {
        this.openFeedback('success', 'File restored');
        this.loadRecycleBin();
      } else {
        this.openFeedback('error', res.data.message);
      }
    } catch (err) {
      this.openFeedback('error', 'Error: ' + err.message);
    }
  };

  permanentlyDelete = async (file) => {
    const token = localStorage.getItem('token');
    try {
      const res = await axios.post(`${BASE_URL}/folder/permanentlyDeleteNode`, { id: file.id }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data.success) {
        this.openFeedback('success', 'File permanently deleted');
        this.loadRecycleBin();
      } else {
        this.openFeedback('error', res.data.message);
      }
    } catch (err) {
      this.openFeedback('error', 'Error: ' + err.message);
    } finally {
      this.setState({ deleteConfirm: null });
    }
  };

  render() {
    const { files, feedback, deleteConfirm } = this.state;

    return (
        <div style={{ padding: 16, width: '100%' }}>
          {files.length > 0 ? (
              files.map(file => (
                  <ListItem
                      key={file.fileNodeId}
                      divider
                      style={{
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        padding: '12px 0',
                      }}
                  >
                    <Box
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                          marginBottom: 8
                        }}
                    >
                      <ListItemIcon style={{ minWidth: 40 }}>
                        {file.type === 'folder' ? <Folder /> : <InsertDriveFile />}
                      </ListItemIcon>
                      <ListItemText primary={file.name} secondary={file.parentName} />
                    </Box>

                    <Box
                        style={{
                          display: 'flex',
                          gap: 8,               // space between buttons
                          width: '100%',
                          justifyContent: 'flex-start',
                          flexWrap: 'wrap',
                        }}
                    >
                      <Button
                          variant="outlined"
                          color="primary"
                          size="small"
                          onClick={() => this.restoreFile(file)}
                          style={{
                            minWidth: 100,      // ensures buttons have minimum width
                            height: 32,         // smaller, consistent height
                          }}
                      >
                        Restore
                      </Button>
                      <Button
                          variant="outlined"
                          color="secondary"
                          size="small"
                          onClick={() => this.setState({ deleteConfirm: file })}
                          style={{
                            minWidth: 100,
                            height: 32,
                          }}
                      >
                        Delete Permanently
                      </Button>
                    </Box>
                  </ListItem>
              ))
          ) : (
              <Typography>No deleted files</Typography>
          )}

          {/* Confirmation Dialog */}
          <Dialog
              open={!!deleteConfirm}
              onClose={() => this.setState({ deleteConfirm: null })}
              fullWidth
              maxWidth="xs"
          >
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent>
              Are you sure you want to permanently delete "{deleteConfirm?.name}" ?
            </DialogContent>
            <DialogActions style={{ justifyContent: 'flex-end', padding: '8px 16px', marginTop:'8px' }}>
              <Button
                  variant="outlined"
                  onClick={() => this.setState({ deleteConfirm: null })}
              >
                Cancel
              </Button>
              <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.permanentlyDelete(deleteConfirm)}
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>

          <FeedbackBar
              open={feedback.open}
              handleClose={this.closeFeedback}
              severity={feedback.severity}
              message={feedback.message}
          />
        </div>
    );
  }
}

export default RecycleBin;
